import Sidebar from "./Components/Sidebar/Sidebar";

import './App.css'
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home/Home";
import About from "./Pages/About/About";
import Services from "./Pages/Services/Services";
import Contact from "./Pages/Contact/Contact";
import { BsLinkedin } from "react-icons/bs";
import AOS from "aos";
import "aos/dist/aos.css";
import Projects from "./Pages/Projects/Projects";
import Project from "./Pages/Project/Project";
import Blog from "./Pages/Resume/Blog";
import { useEffect } from "react";

function App() {
  
  useEffect(() => {
    AOS.init({ duration: 2000 });
    AOS.refresh();
  }, []);
  return (
    <div className="app scrollBar font-serif text-gray-100">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Sidebar />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/project/:projectId" element={<Project />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <div>
        <div className="right-0 bottom-0 mr-1 mb-1 fixed">
          <a target="_blank" href="https://www.linkedin.com/in/rokibulslam/">
            <div className="linkedinPulse">
              <button className="text-white z-40 bg-sky-600 p-3 rounded-full hover:bg-red-600">
                <BsLinkedin />
              </button>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;
